import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import isArray from 'lodash/isArray'
import { ButtonTabs } from 'ui/buttons'
import { useField } from '@morningtrain/react-fields'
import withTranslations from '../hoc/withTranslations'
import * as UI from 'ui'

function TabsField (props) {
  let {
    id,
    name,
    value,
    onChange,
    options,
    wrap,
    readOnly = false,
  } = useField(props)

  if (props.only && isArray(props.only)) {
    options = options.filter(option => {
      return props.only.indexOf(option.value) >= 0
    })
  }

  function maybeCastValue (val) {
    if (val === true) {
      return 1
    }
    if (val === false) {
      return 0
    }

    return val
  }

  return wrap(() => (
    <>
      <input type='hidden' name={name} value={maybeCastValue(value)} />
      <ButtonTabs classNames={props.className} size={props.size} fullWidth={props.fullWidth}>
        {options.map(option => (
          <button
            key={option.value}
            type="button"
            className={(`${option.value}` === `${value}` || option.value == value) ? 'active' : 'inactive'}
            onClick={() => !readOnly && onChange(option.value)}
            disabled={readOnly}
          >
            <span className="flex items-center justify-center">
              {props.iconMap && !!props.iconMap[option.value]
                ? (
                  <UI.WithIcon icon={iconMap[option.value]}>
                    <UI.Text block className="mt-0.5">
                      {option.label}
                    </UI.Text>
                  </UI.WithIcon>
                )
                : option.label}
            </span>
          </button>
        ))}
      </ButtonTabs>
    </>
  ))
}

TabsField.defaultProps = {
  label: null,
  only: null
}

TabsField.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  enum: PropTypes.string.isRequired,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  only: PropTypes.array,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  iconMap: PropTypes.object,
  readOnly: PropTypes.bool,
}

export default withTranslations(observer(TabsField))
